import { Badge, Box, IconButton, Tooltip, Typography } from "@mui/material";
import MUIButton from "./MUIButton";
import MUICancelButton from "./MuiCancelButton";
import dayjs from "dayjs";
import { PickersDay } from "@mui/x-date-pickers/PickersDay/PickersDay";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CalendarIcon from "../../assets/Icons/CalendarIcon";
import { useState } from "react";
import ClearIcon from '@mui/icons-material/Clear';

const MuiDatePicker = (props) => {

    const {
        value,
        onChange,
        slotProps,
        disableOpenPicker,
        minDate,
        maxDate,
        disabled
    } = props

    const [isOpenDatePicker, setIsOpenDatePicker] = useState(false)

    const CustomActionBar = () => (
        <>
            {/* <Box>
                <Box sx={{ padding: 1, position: 'absolute', right: 0, top: 0, left: 0 }}>
                    <Tooltip
                        title={"Close"}
                        arrow
                    >
                        <IconButton size="small" onClick={() => {
                            setIsOpenDatePicker(false);
                        }}>
                            <ClearIcon sx={{ fontSize: '18px', color: '#a2a2a2' }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box> */}
            <Box sx={{ padding: 1, position: 'absolute', right: 0, bottom: 0, left: 0 }}>

                <MUICancelButton title='Cancel' sx={{ width: '130px' }}
                    onClick={() => {
                        onChange(null)
                        setIsOpenDatePicker(false)
                    }}
                />
            </Box>
            <Box sx={{ padding: 1, position: 'absolute', right: 0, bottom: 0 }}>
                <MUIButton title='Apply' sx={{ width: '130px' }} onClick={() => setIsOpenDatePicker(false)} />
            </Box>
        </>
    );

    const CustomDay = (props) => {
        const { day, ...other } = props;
        const isToday = dayjs()?.isSame(day, 'day');

        return (
            <Badge
                key={day?.toString()}
                overlap="circular"
                color="primary"
                variant="dot"
                invisible={!isToday}
            >
                <PickersDay
                    {...other}
                    day={day}
                />
            </Badge>
        );
    };

    return (
        // <DatePicker
        //     open={isOpenDatePicker}
        //     onOpen={() => setIsOpenDatePicker(true)}
        //     value={value}
        //     onChange={(newValue) => {
        //         onChange(newValue)
        //         setTimeout(() => setIsOpenDatePicker(false), 100); //
        //     }}
        //     slotProps={{
        //         textField: {
        //             ...slotProps?.textField,
        //             size: 'small',
        //             InputProps: { sx: { borderRadius: '10px', height: '35px' } },
        //             helperText: slotProps?.textField?.helperText
        //         },
        //         popper: { placement: 'auto' }
        //     }}
        //     slots={{
        //         openPickerIcon: CalendarIcon,
        //         actionBar: CustomActionBar,
        //         day: CustomDay,
        //     }}
        //     dayOfWeekFormatter={(weekday) => `${weekday.format('dd')}`}
        //     format="DD-MM-YYYY"
        //     closeOnSelect={false}
        //     sx={{
        //         width: "100%",
        //         '& .MuiInputBase-input': {
        //             fontSize: '14px'
        //         },
        //         "& .MuiFormHelperText-root": {
        //             color: slotProps?.textField?.helperText ? "red" : "inherit",
        //             marginLeft: '-1px'
        //         },
        //         "& .MuiInputBase-input.Mui-disabled": {
        //             cursor: "not-allowed"
        //         }
        //     }}
        //     showDaysOutsideCurrentMonth
        //     disableOpenPicker={disableOpenPicker}
        //     minDate={minDate}
        //     disabled={disabled}
        // />

        <DatePicker
            open={isOpenDatePicker}
            onOpen={() => setIsOpenDatePicker(true)}
            onClose={() => setIsOpenDatePicker(false)}
            value={value}
            onChange={(newValue) => {
                onChange(newValue);
            }}
            slotProps={{
                textField: {
                    ...slotProps?.textField,
                    size: "small",
                    InputProps: { sx: { borderRadius: "10px", height: "35px" } },
                    helperText: slotProps?.textField?.helperText,
                },
                actionBar: { actions: ["accept"] },
            }}
            slots={{
                openPickerIcon: CalendarIcon,
                actionBar: (props) => <CustomActionBar {...props} />,
                day: CustomDay,
            }}
            dayOfWeekFormatter={(weekday) => `${weekday.format("dd")}`}
            format="DD-MM-YYYY"
            closeOnSelect={false}
            sx={{
                width: "100%",
                "& .MuiInputBase-input": { fontSize: "14px" },
                "& .MuiFormHelperText-root": {
                    color: slotProps?.textField?.helperText ? "red" : "inherit",
                    marginLeft: "-1px",
                },
                "& .MuiInputBase-input.Mui-disabled": { cursor: "not-allowed" },
            }}
            showDaysOutsideCurrentMonth
            disableOpenPicker={disableOpenPicker}
            minDate={minDate}
            maxDate={maxDate}
            disabled={disabled}
        />

    )
}

export default MuiDatePicker